import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'chicilon-no-permission',
  imports: [TranslateModule],
  templateUrl: './no-permission.component.html',
  styleUrl: './no-permission.component.scss'
})
export class NoPermissionComponent {}
